import i18n from '@/locale/i18n'

import greenchannel from '@/page/greenchannel/index'
import news from '@/page/greenchannel/news'
import passing from '@/page/greenchannel/passing'
import luckyDraw from '@/page/greenchannel/luckyDraw'
import guide from '@/page/greenchannel/guide'
import param from '@/page/greenchannel/param'

export default [
    {
        path: '/greenchannel',
        component: greenchannel,
        meta: { title: i18n.t('greenchannel.channel1') }
    },
    {
        path: '/greenchannel/news',
        component: news,
        meta: { title: i18n.t('greenchannel.channel1') }
    },
    {
        path: '/guide',
        component: guide,
        meta: { title: i18n.t('greenchannel.guide1') }
    },
    {
        path: '/passing',
        component: passing,
        meta: { title: i18n.t('greenchannelpassing.title') }
    },
    {
        path: '/luckyDraw',
        component: luckyDraw,
        meta: { title: i18n.t('draw.c111') }
    },
    {
        path: '/param',
        component: param,
        meta: { title: '获取参数' }
    }
]



// WEBPACK FOOTER //
// ./src/router/greenchannel/index.js